(function () {
  function getHeroRoot() {
    return document.querySelector('[id^="Hero-"]');
  }

  function formatMoneySafe(cents) {
    try {
      // Si ton thème expose moneyFormat
      if (window.Shopify?.formatMoney && (window.theme?.moneyFormat || window.Shopify?.money_format)) {
        return Shopify.formatMoney(cents, window.theme?.moneyFormat || window.Shopify.money_format);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function findOutsideHero(heroRoot, selector, predicate) {
    const nodes = Array.from(document.querySelectorAll(selector)).filter((n) => !heroRoot.contains(n));
    return predicate ? (nodes.find(predicate) || null) : (nodes[0] || null);
  }

  function setTextIfChanged(el, nextText) {
    const cur = (el.textContent || '').trim();
    const nxt = (nextText || '').trim();
    if (cur !== nxt) el.textContent = nxt;
  }

  function syncStockFromDOM(hero) {
    const heroInv = hero.querySelector('product-inventory');
    const srcInv = findOutsideHero(hero, 'product-inventory');

    if (!heroInv || !srcInv) return;

    // Icon classes (couleur/état)
    const heroIcon = heroInv.querySelector('.product-inventory__icon');
    const srcIcon = srcInv.querySelector('.product-inventory__icon');
    if (heroIcon && srcIcon) heroIcon.className = srcIcon.className;

    // Text (conserve <strong> ETA)
    const heroText = heroInv.querySelector('.product-inventory__text');
    const srcText = srcInv.querySelector('.product-inventory__text');
    if (heroText && srcText) {
      const curHTML = heroText.innerHTML.trim();
      const nxtHTML = srcText.innerHTML.trim();
      if (curHTML !== nxtHTML) heroText.innerHTML = nxtHTML;
    }
  }

  function syncPriceFromEventOrDOM(hero, detail) {
    const heroPrice = hero.querySelector('product-price div[ref="priceContainer"] .price');
    if (!heroPrice) return;

    // 1) ✅ Source fiable : event.detail.resource.price
    const cents = detail?.resource?.price;
    if (typeof cents === 'number') {
      setTextIfChanged(heroPrice, formatMoneySafe(cents));
      return;
    }

    // 2) Fallback DOM (scopé par product-id si possible)
    const heroProductPrice = hero.querySelector('product-price');
    const pid = heroProductPrice?.getAttribute('data-product-id');

    const srcPrice = findOutsideHero(
      hero,
      'product-price div[ref="priceContainer"] .price',
      pid
        ? (el) => el.closest('product-price')?.getAttribute('data-product-id') === pid
        : null
    );

    if (srcPrice) setTextIfChanged(heroPrice, srcPrice.textContent);
  }

  function syncAll(detail = null) {
    const hero = getHeroRoot();
    if (!hero) return;

    syncPriceFromEventOrDOM(hero, detail);
    syncStockFromDOM(hero);
  }

  // ✅ Event natif du thème (confirmé)
  document.addEventListener('variant:update', (e) => {
  const hero = document.querySelector('[id^="Hero-"]');
  if (!hero) return;

  const heroPriceBlock = hero.querySelector('product-price');
  const heroProductId = heroPriceBlock?.getAttribute('data-product-id');

  const eventProductId = e.detail?.data?.productId;

  // ✅ Filtre CRITIQUE
  if (!eventProductId || !heroProductId || eventProductId !== heroProductId) {
    return; // Ignore les events des produits complémentaires
  }

  queueMicrotask(() => syncAll(e.detail || null));
}, true);

  // Sync initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAll(null), { once: true });
  } else {
    syncAll(null);
  }

  console.log('✅ UT hero sync v3 ready (price from event, stock from DOM).');
})();